import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs';

import Meta from "../components/layout/Meta";
import { Path, PathGenerator } from "../constants/path";
import { ExternalPath } from "../constants/path";
import { Link, Button } from "../components/util/Clickable";
import { settings } from "../assets/settings";
import SearchForm from "../components/forms/SearchForm";

import logo from "../assets/images/logo_light.png";

class RootScreen extends Component {

  state = {
    query: settings.search_default()
  };

  componentDidMount = () => {
  }

  toSearch = (values) => {
    const param = qs.stringify(values);
    this.props.history.push( Path.facilities.url + "?" + param );
  }

  toMapSearch = (values) => {
    const param = qs.stringify(values);
    this.props.history.push( Path.map.url + "?" + param );
  }

  render = () => {
    return (
      <div>
        <Meta />
        <div className="uk-section uk-position-relative">
          <div className="uk-position-cover" style={{backgroundColor:"#F8F0D9"}}>
          </div>
          <div className="uk-container uk-container-xsmall uk-position-relative">
            <div className="uk-margin-small uk-text-center">
              <img className="uk-width-large@s uk-width-medium" src={logo} alt={settings.title} />
            </div>
            <p className="uk-margin uk-text-center uk-h3 uk-text-nowrap">
              公式サイト予約だから<wbr/>最低価格保証のホテル・旅館さがし
            </p>
            <div className="uk-margin-medium uk-width-1-1 uk-background-muted uk-padding">
              <SearchForm initialValues={this.state.query} onSubmit={this.toSearch} onMapSubmit={this.toMapSearch} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RootScreen))